import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ReactHtmlParser from "react-html-parser";
import { exportDocument } from "../../helpers";
import { TriggerLine } from "./index";

class Text extends Component {
  render() {
    const { title, leftSide, rightSide, dark } = this.props;
    const firstTitle = (title) => (
      <h5 className="titulo-c-fondo font-weight-bold p-1 pl-4">{title}</h5>
    );
    const paragraph = (text) => (
      <p className={` pl-1 text-justify ${dark ? "text-white-50" : ""}`}>
        {text.includes("<" || ">") ? ReactHtmlParser(text) : text}
      </p>
    );
    const imageFluid = (imageUrl) => (
      <img src={imageUrl} className="img-fluid" alt="imagen respectiva" />
    );
    const links = (link, content) => (
      <p
        onClick={() => exportDocument(link)}
        class="pl-4 my-0"
        style={{
          cursor: "pointer",
          textDecoration: "underline",
          color: "#0f69b4",
        }}
      >
        {content}
      </p>
    );
    return (
      <div>
        <div className="container">
          <div className="mx-md-5 mt-5">
            {title && firstTitle(title)}
            <div className="row">
              <div className={`col-md-${!!!rightSide ? "12" : "6"}`}>
                {leftSide.map(
                  (obj) =>
                    (!!obj.image && imageFluid(obj.image)) ||
                    (!!obj.paragraph && paragraph(obj.paragraph)) ||
                    (!!obj.link && links(obj.link, obj.name))
                )}
              </div>
              {!!rightSide && (
                <div className="col-md-6">
                  {rightSide.map(
                    (obj) =>
                      (!!obj.image && imageFluid(obj.image)) ||
                      (!!obj.paragraph && paragraph(obj.paragraph)) ||
                      (!!obj.link && links(obj.link, obj.name)) ||
                      (!!obj.trigger && (
                        <div className="px-3">
                          <TriggerLine />
                        </div>
                      ))
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Text.propTypes = {
  title: PropTypes.string,
  leftSide: PropTypes.object,
  rightSide: PropTypes.object,
};

const mapStateToProps = (state) => ({
  dark: state.dark,
});

export default connect(mapStateToProps, {})(Text);
